<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.editDepartments') }}</h1>
      <div class="form-container">
        <PositionForm v-if="relations.departments" :data="relations.instance" @save="save"></PositionForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import {mapState} from 'vuex'
  import PositionForm from "@/components/PositionForm"

  export default {
    components: {
      PositionForm,
      DashboardLayout,
    },
    methods: {
      save(payload) {
        this.$store.dispatch('Moderator/update', {actionType: 'positions', payload}).then(() =>
          this.$router.push({ name: 'positions'}))
      }
    },
    mounted() {
      this.$store.commit('Moderator/CLEAR', 'relations')
      this.$store.dispatch('Moderator/getRelations', {actionType: 'positions', id: this.$route.params.id})
    },
    computed: {
      ...mapState('Moderator', ['relations']),
      breadcrumbs() {
        return [
          {name: 'positions', path: 'positions'},
          {name: 'editPosition'}
        ]
      }
    }
  }
</script>
